// the semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.
;(function ( $, window, document, undefined ) {

	"use strict";

		// undefined is used here as the undefined global variable in ECMAScript 3 is
		// mutable (ie. it can be changed by someone else). undefined isn't really being
		// passed in so we can ensure the value of it is truly undefined. In ES5, undefined
		// can no longer be modified.

		// window and document are passed through as local variable rather than global
		// as this (slightly) quickens the resolution process and can be more efficiently
		// minified (especially when both are regularly referenced in your plugin).

		// Create the defaults once
		var pluginName = "scrollEvent",
				defaults = {
					elements: [],
					gaCallback : function(){}
				},
				//callback = function(){},
				cache = {};

		// The actual plugin constructor
		function ScrollEvent ( element, options ) {
				this.element = element;
				// jQuery has an extend method which merges the contents of two or
				// more objects, storing the result in the first object. The first object
				// is generally empty as we don't want to alter the default options for
				// future instances of the plugin
				this.settings = $.extend( {}, defaults, options );
				this._defaults = defaults;
				this._name = pluginName;
				
                // TODO: fix new Map usage.
                this.init();
		}

		// Avoid Plugin.prototype conflicts
		$.extend(ScrollEvent.prototype, {
				init: function () {
						// Place initialization logic here
						// You already have access to the DOM element and
						// the options via the instance, e.g. this.element
						// and this.settings
						// you can add more functions like the one below and
						// call them like so: this.yourOtherFunction(this.element, this.settings).

						var cb = this.settings.gaCallback;
						//populate cache
						$.each(this.settings.elements, function(index, elem) {
							var pos = $(elem).offset().top+100;
							pos = Math.round(pos);
							cache[elem] = {pos: pos, callback: cb, elem:elem};
						});

						$(window).on('scroll.IP', throttle(this.checkScrollElems, 500));
				},
				checkScrollElems: function () {
					 //var docHeight = $(document).height(), 
			        var winHeight = window.innerHeight ? window.innerHeight : $window.height(), 
			        scrollDistance = $(window).scrollTop() + winHeight 

					var keys = Object.keys(cache);
					if(keys.length === 0){
						$(window).off('scroll.IP');
					}
					var hits = [];
					
					for (var i = 0 ; i < keys.length ; i++) {
						var elm = cache[keys[i]];
						var pos = elm.pos;
							if(scrollDistance >= pos){
								//Send event
								if(typeof elm.callback === 'function'){
									elm.callback(keys[i]);
								}
								//console.log("Scroll past: "+key);
								hits.push(keys[i]);
							}
							
					};

					/*cache.forEach(function(value,key, map) {
							var pos = value.pos;
							if(scrollDistance >= pos){
								//Send event
								if(typeof value.callback === 'function'){
									value.callback(key);
								}
								//console.log("Scroll past: "+key);
								hits.push(key);
							}
						});*/

					//Clean up
					$.each(hits, function(index, elem){
						delete cache[elem];
					});

				},
				addScrollPos : function (elem, callback){
					//if(!cache.has(elem)){
					var pos = $(elem).offset().top+100;
							pos = Math.round(pos);
							cache[elem] = {pos: pos, callback: callback, elem:elem};
						//}
				},

				reInitializePositions : function (){
				    var keys = Object.keys(cache);
				    for (var i = 0 ; i < keys.length ; i++) {
				        var elm = cache[keys[i]];
				        var elemID = elm.elem;
				        var pos = $(elemID).offset().top+100;
				        pos = Math.round(pos);
				        elm.pos = pos;
				    };
				},
                
				alertCache: function () {
				    var keys = Object.keys(cache);
				    var msg = "Cacheentries";
				    for (var i = 0 ; i < keys.length ; i++) {
				        var elm = cache[keys[i]];
				       msg += 'ID' + elm.elem + ', top:' + elm.pos;
				    };
				    alert(msg);
				}
		});

		
		// A really lightweight plugin wrapper around the constructor,
		// preventing against multiple instantiations
		/*$.fn[ pluginName ] = function ( options ) {
				return this.each(function() {
						if ( !$.data( this, "plugin_" + pluginName ) ) {
								$.data( this, "plugin_" + pluginName, new ScrollEvent( this, options ) );
						}
				});
		};*/

		 $.fn[pluginName] = function ( options ) {
        var args = arguments;

        // Is the first parameter an object (options), or was omitted,
        // instantiate a new instance of the plugin.
        if (options === undefined || typeof options === 'object') {
            return this.each(function () {

                // Only allow the plugin to be instantiated once,
                // so we check that the element has no plugin instantiation yet
                if (!$.data(this, 'plugin_' + pluginName)) {

                    // if it has no instance, create a new one,
                    // pass options to our plugin constructor,
                    // and store the plugin instance
                    // in the elements jQuery data object.
                    $.data(this, 'plugin_' + pluginName, new ScrollEvent( this, options ));
                }
            });

        // If the first parameter is a string and it doesn't start
        // with an underscore or "contains" the `init`-function,
        // treat this as a call to a public method.
        } else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {

            // Cache the method call
            // to make it possible
            // to return a value
            var returns;

            this.each(function () {
                var instance = $.data(this, 'plugin_' + pluginName);

                if(instance === undefined){
                	instance = new ScrollEvent( this, {});
                	 $.data(this, 'plugin_' + pluginName, instance);
                }

                // Tests that there's already a plugin-instance
                // and checks that the requested public method exists
                if (instance instanceof ScrollEvent && typeof instance[options] === 'function') {

                    // Call the method of our plugin instance,
                    // and pass it the supplied arguments.
                    returns = instance[options].apply( instance, Array.prototype.slice.call( args, 1 ) );
                }

                // Allow instances to be destroyed via the 'destroy' method
                if (options === 'destroy') {
                  $.data(this, 'plugin_' + pluginName, null);
                }
            });

            // If the earlier cached method
            // gives a value back return the value,
            // otherwise return this to preserve chainability.
            return returns !== undefined ? returns : this;
        }
    };


		/*
     * Throttle function borrowed from:
     * Underscore.js 1.5.2
     * http://underscorejs.org
     * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
     * Underscore may be freely distributed under the MIT license.
     */

    function throttle(func, wait) {
      var context, args, result;
      var timeout = null;
      var previous = 0;
      var later = function() {
        previous = new Date;
        timeout = null;
        result = func.apply(context, args);
      };
      return function() {
        var now = new Date;
        if (!previous) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0) {
          clearTimeout(timeout);
          timeout = null;
          previous = now;
          result = func.apply(context, args);
        } else if (!timeout) {
          timeout = setTimeout(later, remaining);
        }
        return result;
      };
    }




})( jQuery, window, document );

/*
How to call
$(document).ready(function(){
			var options  = {elements: ['#indbetalingafkastomkost', "#pension"], gaCallback: gaCallBack};
			$(window).scrollEvent(options);
		});	
		
		function gaCallBack(lable){
			//doStuff...
		}
}

Eller 
$(document).ready(function(){
	$(window).scrollEvent("addScrollPos",'#pension', function(){alert('hit1')});
});
*/
